import { styled } from "@linaria/react";
import React from "react";
import t from "../../../../i18n";
import ButtonIconV2 from "@ui/ButtonIconV2";
import { DeleteBinLine, FileCopyLine, PencilLine } from "@ui/IconV2/react";

interface P {
  className?: string;
  openEditModal: (e: React.MouseEvent) => void;
  openDuplicateModal: (e: React.MouseEvent) => void;
  openDeleteModal: (e: React.MouseEvent) => void;
}

const ActionIcons = styled.div`
  display: flex;
  align-items: center;
`;

const Actions = ({ className, openEditModal, openDuplicateModal, openDeleteModal }: P) => (
  <ActionIcons className={className} data-cy="setup-action-icons">
    <ButtonIconV2 title={t("projects.actions.edit")} data-cy="edit-setup" onClick={openEditModal}>
      <PencilLine size="m" />
    </ButtonIconV2>
    <ButtonIconV2
      title={t("projects.actions.duplicate")}
      data-cy="duplicate-project"
      onClick={openDuplicateModal}
    >
      <FileCopyLine size="m" />
    </ButtonIconV2>
    <ButtonIconV2
      title={t("projects.actions.delete")}
      data-cy="delete-setup"
      onClick={openDeleteModal}
    >
      <DeleteBinLine size="m" />
    </ButtonIconV2>
  </ActionIcons>
);
export default React.memo(Actions);
